import { render, staticRenderFns } from "./tag.html?vue&type=template&id=330190bc&scoped=true&"
import script from "./tag.js?vue&type=script&lang=js&"
export * from "./tag.js?vue&type=script&lang=js&"
import style0 from "./tag.scss?vue&type=style&index=0&id=330190bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330190bc",
  null
  
)

export default component.exports